
const LoaderAdditionalOptions = {
  CLOSE_ON_FILE_SELECTION: 'loader_additional_options.close_on_file_selection',
  PRINT_SIZES: 'loader_additional_options.print_sizes',
  PRINT_SIZE_MODE: 'loader_additional_options.print_size_mode',
  PREUPLOAD_CONFIRMATION: 'loader_additional_options.preupload_confirmation',
  TARGET_ALBUM: 'loader_additional_options.target_album',
  EXTRA_FILE_TYPES: 'loader_additional_options.extra_file_types',
};

export default LoaderAdditionalOptions;
